// extracted by mini-css-extract-plugin
export default {"chips":"cVQTJ","chips__badge":"KMDvd"};